// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myargic a:hover .textlabel {
  color: hsl(186, 96%, 38%);
  font-weight: 700;
  /*text-decoration:underline;*/
}
.myargic a:hover i {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/website/myargic/myargic.component.scss"],"names":[],"mappings":"AAEQ;EACA,yBAAA;EACA,gBAAA;EACA,6BAAA;AADR;AAGQ;EACI,gBAAA;AADZ","sourcesContent":[".myargic{\r\n    a:hover {\r\n        .textlabel{\r\n        color:hsl(186, 96%, 38%);\r\n        font-weight:700;\r\n        /*text-decoration:underline;*/\r\n        }\r\n        i{\r\n            font-weight:600;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
